module.exports = __webpack_public_path__ + "static/media/MinsportCalendars.0fa92ca0.svg";